@if (markUpContent$ | async; as termsAndPolicy) {
  <ion-content>
    <div class="policyTitleWrapper">
      <span>{{title}}</span>
    </div>
    <div class="detailImgText" [innerHTML]="intTermsAndPolicy ? intTermsAndPolicy : termsAndPolicy"></div>
    <div class="footer-content" slot="fixed">
      <a class="text-link back-to-login" (click)="closeDialog()"> &larr; {{ "accountpage.Back" | translate }}</a>
    </div>
  </ion-content>
} @else {
  <div class="loading-container">
    <div class="loading-wrapper"></div>
  </div>
  <app-in-progress-animation></app-in-progress-animation>
}

<ng-template #loading>
  <div class="loading-container">
    <div class="loading-wrapper"></div>
  </div>
  <app-in-progress-animation></app-in-progress-animation>
</ng-template>